module.exports = __webpack_public_path__ + "img/logo.5722b96a.png";